(function () {
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-tm-tab]');
    var panels = root.querySelectorAll('[data-tm-panel]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-tm-tab');

        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var show = panel.getAttribute('data-tm-panel') === id;
          panel.classList.toggle('is-active', show);
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-tm-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
